import React from 'react';
import './Thankyou.css';
import { Link } from 'react-router-dom';


const ThankYou = () => {

  return (
    <div className="ThankYoucontainer center">
      <h1>Thank You!</h1>
      <p>Your exam has been submitted successfully.</p>
      <Link to="/"><button className='exitButton'>Exit</button></Link>
    </div>
  );
};

export default ThankYou;
